module.exports = __webpack_public_path__ + "media/arneo_introduction.96cff857.mp4";